import { useEffect, useState } from 'react';

/**
 * Garde un élément monté le temps de son animation de sortie, pour qu'il reparte par le même
 * chemin qu'à l'entrée (un panneau qui apparaît en grandissant disparaît en rétrécissant, il ne
 * s'évanouit pas d'un coup).
 *
 * @returns {{ monte: boolean, sortant: boolean }} — appliquer la classe `aqs-sortie` si `sortant`.
 */
export default function usePresence(visible, dureeSortieMs = 260) {
  const [monte, setMonte] = useState(visible);

  useEffect(() => {
    if (visible) {
      setMonte(true);
      return undefined;
    }
    const minuteur = setTimeout(() => setMonte(false), dureeSortieMs);
    return () => clearTimeout(minuteur);
  }, [visible, dureeSortieMs]);

  return { monte: visible || monte, sortant: !visible && monte };
}
